import React from 'react';
import AppFormikInput from 'components/form/formik/input/input';
import useAddWithdraw from '../hooks/use-add-withdraw';
import DialogForm from 'components/dialog/dialog-form';
import { TDialogWrapperComponent } from 'components/dialog/index.types';

type TValues = {
    nexUserId: string;
    amount: string;
};

const initValues: TValues = {
    nexUserId: '',
    amount: '',
};

const DialogAdd: React.FC<TDialogWrapperComponent> = ({
    isDialogOpen,
    setIsDialogOpen,
    asyncStatesHandlers,
}) => {
    const [onWithdrawAdd, { isLoading }] = useAddWithdraw(asyncStatesHandlers);
    return (
        <DialogForm<TValues>
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            title={'Create Cash Withdrawal Transaction'}
            onSubmit={async (values) => {
                await onWithdrawAdd(values);
            }}
            isLoading={isLoading}
            initValues={initValues}
            validate={(values) => {
                let errors: Partial<TValues> = {};

                if (values.nexUserId.length === 0) {
                    errors.nexUserId = 'Required';
                }
                if (values.amount.length === 0) {
                    errors.amount = 'Required';
                }
                return errors;
            }}
        >
            <AppFormikInput
                name={'nexUserId'}
                placeholder={'User Name'}
            />
            <AppFormikInput name={'amount'} placeholder={'Amount RP'} />
        </DialogForm>
    );
};

export default DialogAdd;
